import React from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, DatePicker, Checkbox, Modal} from 'antd'
import { checkMoreThanLess } from '../../../utils/formatdate'
import moment from 'moment'

const { Text, Title } = Typography
const { Option } = Select;
const { TextArea } = Input

class ModalConfirmForm extends React.PureComponent {

    state = {
        preLoadSubmitModal:false
    }

    onSubmit = async (values) =>{
		const { data, submitToSend, valueConfirm } = this.props
        await this.setState({
			preLoadOnsubmit: true
		})
		valueConfirm.ModalNoteApprove = ''

        await submitToSend(valueConfirm)
	}

	submitForm = async (e) =>{
		const { data, submitToSend, valueConfirm } = this.props
        const { form, client } = this.props
        

        e.preventDefault()
		form.validateFields(async (err, values) => {
			// alert('xxxx')
			if (!err) {
				valueConfirm.ModalNoteApprove = values.noteApprove ? values.noteApprove : ''
				// console.log('valueConfirm',valueConfirm)
				await submitToSend(valueConfirm)
			}
        })
	}

	closeModal = async () =>{
        this.props.hideModal()
	}

	async componentDidUpdate(prevProps, prevState, snapshot){
		const { showModal } = this.props
        if(!prevProps.showModal){
            await this.setState({
                preLoadOnsubmit: false
            })
        }
	}

	async componentDidMount() {
	}

	render() {
        const { 
			title, 
			subtitle, 
			showModal, 
			btnOk, 
			btnCancel, 
			submitToSend, 
			ModalFormTextArea = false, 
			ModalFormTextAreaRequie = false
		} = this.props
        const { getFieldDecorator } = this.props.form
		const { preLoadOnsubmit } = this.state

		return (
			<>
                <Modal
                    destroyOnClose={true}
                     visible={showModal}
                        maskClosable={false}
                     title={title}
                        // onOk={ () =>{
                        //     this.onSubmit()
                        // }}
                     onCancel={
                        () =>{
                                 this.closeModal()
                        }
                     }
					width={600}
                    okText={ btnOk }
                    cancelText={ btnCancel }
                    footer={null}
                    className={ ModalFormTextArea ? 'showTextArrea'  : '' }
                >
                    {
						ModalFormTextArea ?
							<>
								{
									subtitle &&
									<span>
										{subtitle}
									</span>
								}
								
								<Form ref={this.formRef}>
									<Row gutter={16} type="flex" justify="left" align="top" >
                                        <Col xs={24} md={24} >
                                            <Form.Item label={"หมายเหตุ"}>
                                                { getFieldDecorator("noteApprove", {
                                                    initialValue: "",
                                                    rules:  [{ 
                                                        required: ModalFormTextAreaRequie, 
                                                        message: 'กรุณากรอก หมายเหตุ',
                                                    }],
                                                })(
                                                    <TextArea rows={3} className='block-news' />
                                                )}
                                            </Form.Item>
										</Col>
									
										<Col xs={24} md={24}  align={"right"}>
											<Button 
												type="primary" 
												className="mt-1 mr-3 btn-white-red"
												disabled={ preLoadOnsubmit }
												// onClick={ this.searchForm }
												onClick={async ()=> 
													this.closeModal()
												}
											>
												{btnCancel}
											</Button>
											
											<Button 
												type="primary " 
												className="mt-1 color-white"
												htmlType="submit"
												disabled={ preLoadOnsubmit }
                                                onClick={
													this.submitForm
												}
											>
												{btnOk}
											</Button>
										</Col>
									</Row>
								</Form>
							</>
						:
							<Form ref={this.formRef}>
								<Row gutter={16} type="flex" justify="left" align="top">
									{
										subtitle &&
										<Col xs={24} md={24} >
											<span>
												{subtitle}
											</span>
										</Col>
									}
									<Col xs={24} md={24} align={"right"}>
										<Button 
											type="primary" 
											className="mt-1 mr-3 btn-white-red"
											disabled={ preLoadOnsubmit }
											// onClick={ this.searchForm }
											onClick={async ()=> 
												this.closeModal()
											}
										>
											{btnCancel}
										</Button>
										
										<Button 
											type="primary " 
											className="mt-1 color-white"
											htmlType="submit"
											disabled={ preLoadOnsubmit }
											// onClick={ this.searchForm }
											onClick={async ()=> 
												this.onSubmit()
											}
										>
											{btnOk}
										</Button>
									</Col>
								</Row>
							</Form>
					}
				</Modal>
            </>
		)
	}
}

ModalConfirmForm.defaultProps = {
	autoFocus: false
}

ModalConfirmForm.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedDelegateFormModal = Form.create()(ModalConfirmForm)

export default withApollo(WrappedDelegateFormModal)